import { Div2, Span } from "../styled_components/divs";
import t from "../../../helpers/t";
import { rbac } from "../index";
import React from "react";
import SwitchPaddle from "../../../components/switchpaddle";

const ItemMobile = (props) => {
  const {
    localVoucher,
    setInitialized,
    voucherPending,
    onChangeStatus,
    currentUrl,
    onRemoveVoucher,
    index,
  } = props;
  return (
    <>
      <div
        className={
          "inb-c-item inb-c-item--resource row hide-for-large" +
          (localVoucher.status ? " not-marked" : " red-marked")
        }
        key={"div_row_mobile_" + localVoucher.id}
      >
        <div
          className="medium-7 small-7 column  padding-1 show-label"
          id="order-id"
          title={t("name")}
          key={"div_resource_id_" + localVoucher.id}
        >
          <Span>{localVoucher.name}</Span>
        </div>
        <div
          className="medium-7 small-7 column  show-label"
          id="name-bike"
          title={t("description", null, "capital")}
          key={"div_resource_name_" + localVoucher.id}
        >
          <span className="text-nowrap">{localVoucher.description}</span>
        </div>
        <div
          className="medium-7 small-7 column show-label"
          id="inb-contingent"
          title={t("voucher_unit", null, "capital")}
          key={"div_resource_contingent_" + localVoucher.id}
        >
          {t("voucher_unit_" + localVoucher.voucher_unit)}
        </div>

        <div
          className="medium-7 small-7 column show-label"
          title={t("voucher_value", null, "capital")}
          key={"div_voucher_value_" + localVoucher.id}
        >
          {localVoucher.voucher_value}
        </div>
        <div
          className="medium-12 small-12 inb-group-item"
          id="group-item-3"
          key={"div_resource_buttons_group_" + localVoucher.id}
        >
          <div className="medium-8 small-8 medium-offset-0" id="inb-group-status-time">
            <div
              className="medium-2 small-5"
              id="status"
              title="Status"
              style={{ paddingTop: "17px" }}
            >
              &nbsp;
            </div>
            <div
              className="medium-6 small-6 show-label"
              id="status"
              title={t("active", null, "capital")}
              style={{ paddingTop: "17px" }}
            >
              {voucherPending === localVoucher.id ? (
                <>
                  <span>
                    <img
                      alt="RollingLoader"
                      className="rollingLoader colorize-black"
                      src={"assets/img/rolling_loader.svg"}
                    />{" "}
                  </span>
                </>
              ) : (
                <SwitchPaddle
                  name={localVoucher.id}
                  disabled={rbac.hasPermission("editVoucher") ? "" : "disabled"}
                  value={localVoucher.status}
                  onChange={onChangeStatus}
                  label={""}
                />
              )}
            </div>
          </div>

          <div
            className="medium-4 small-4 medium-offset-0 column item-button-group padding-05"
            key={"div_resource_edit_" + localVoucher.id}
          >
            <div className="medium-3 small-3 medium-offset-0 column" id="group-icon-one">
              {rbac.hasPermission("editVoucher") && (
                <div
                  className="button-container-vouchers left"
                  key={"div_voucher_button_container_edit_" + localVoucher.id}
                >
                  <a
                    href={"/vouchers/" + localVoucher.id + currentUrl.search}
                    title={t("edit")}
                    key={"a_rvoucher_edit_" + localVoucher.id}
                    data-inb-action-link="edit"
                  >
                    <button
                      type="button"
                      className="inb-round-btn hollow round float-left"
                      key={"a_button_voucher_edit_" + localVoucher.id}
                    >
                      <div className="inb-fi-edit"> </div>
                    </button>
                  </a>
                </div>
              )}
              {rbac.hasPermission("removeVoucher") && (
                <div
                  className="button-container-vouchers"
                  key={"div_voucher_button_container_delete_" + localVoucher.id}
                >
                  <a
                    href="#"
                    className="inb-reservation__pdf2"
                    title={t("delete")}
                    key={"a_voucher_delete_" + localVoucher.id}
                    data-inb-action-link="delete"
                  >
                    <button
                      type="button"
                      className="inb-round-btn hollow round float-left"
                      key={"a_button_voucher_delete_" + localVoucher.id}
                      onClick={() => onRemoveVoucher(localVoucher)}
                    >
                      <div className="inb-fi-remove"> </div>
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemMobile;
